export default "__VITE_ASSET__CvYe2EDO__"